export default [
  {
    title: "Tìm kiếm hình ảnh",
    group: "apps",
    icon: "fa-tachometer-alt",
    name: "Dashboard",
  },
  {
    title: "Sản phẩm",
    group: "apps",
    icon: "fa-shopping-cart",
    name: "ProductList",
  },
  {
    title: "Nhân viên",
    group: "apps",
    name: "StaffList",
    icon: "fa-user",
    is_admin: 1,
    component: "StaffList",
    children: [
      {
        name: "StaffDetail",
        title: "Chi tiết nhân viên",
        component: "StaffDetail",
        is_admin: 1,
      },
    ],
  },
];
